import { styleOverrides } from "./styleOverrides";

const MuiInputBase = {
  styleOverrides,
};

export { MuiInputBase };
